import React from 'react';
import { ICustomIconProps } from './types';

export const ShipmentBox: React.FC<ICustomIconProps> = ({ size = 32, color = '#BFBFBF' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 32 32' fill='none'>
    <path
      d='M26.947 10.4266L16.6803 16.3733C16.267 16.6133 15.747 16.6133 15.3203 16.3733L5.05362 10.4266C4.32029 9.99992 4.13362 8.99992 4.69362 8.37326C5.08029 7.93326 5.52029 7.57326 5.98695 7.31992L13.2136 3.31992C14.7603 2.45326 17.267 2.45326 18.8136 3.31992L26.0403 7.31992C26.507 7.57326 26.947 7.94659 27.3336 8.37326C27.867 8.99992 27.6803 9.99992 26.947 10.4266Z'
      fill={color}
    />
    <path
      d='M15.2403 18.8535V27.9468C15.2403 28.9602 14.2136 29.6268 13.307 29.1868C10.5603 27.8402 5.93363 25.3202 5.93363 25.3202C4.30697 24.4002 2.97363 22.0802 2.97363 20.1735V13.2935C2.97363 12.2402 4.0803 11.5735 4.98697 12.0935L14.5736 17.6535C14.9736 17.9068 15.2403 18.3602 15.2403 18.8535Z'
      fill={color}
    />
    <path
      d='M16.7598 18.8535V27.9468C16.7598 28.9602 17.7864 29.6268 18.6931 29.1868C21.4398 27.8402 26.0664 25.3202 26.0664 25.3202C27.6931 24.4002 29.0264 22.0802 29.0264 20.1735V13.2935C29.0264 12.2402 27.9198 11.5735 27.0131 12.0935L17.4264 17.6535C17.0264 17.9068 16.7598 18.3602 16.7598 18.8535Z'
      fill={color}
    />
  </svg>
);
